//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getNewsDetail,getLiveMessage,getCommentList} from '@/api/qf'
import MescrollVue from 'mescroll.js/mescroll.vue'
import 'mescroll.js/mescroll.min.css'

export default {
  data () {
    return {
      newsId:'',
      newsInfo:{},
      newsLive:{},
      isShowVideo:true,
      tabType: 0,
      isShowCommentInput:false,
      descMessage: '顺序',
      isDesc:false,
      tab0: {mescroll: null, list: [], isListInit: false}, // 直播
      tab1: {mescroll: null, list: [], isListInit: false}, // 评论
      topMessageList:[],
      liveMessageList:[],
      newCommentList:[],
      htmlList:[],
      timestamp:'',
    }
  },
  components: {
    MescrollVue
  },

  mounted () {
    this.newsId = this.$route.query.newsId;
    this.get_news_detail();
    this.changeTab(0)
  },
  methods: {
    mescrollLiveMessageInit (mescroll) {
      mescroll.tabType = 0; // 加入标记,便于在回调中取到对应的list
      this.tab0.mescroll = mescroll;
    },
    mescrollCommentInit (mescroll) {
      mescroll.tabType = 1;
      this.tab1.mescroll = mescroll;
    },
    get_news_detail(){
      let params = {newsId:this.newsId}
      getNewsDetail(params).then((res) => {
        this.newsInfo = res.data;
        this.newsLive = this.newsInfo.newsLive;
        document.title = this.newsInfo.title;
        if(this.newsLive.type == 1){ //图文直播
          this.isShowVideo = false;
        }else{ //视频直播
          var videoType = "";
          var arr = null;
          var srcUrl = "";
          var container = document.getElementById('live');
          if((this.newsLive.liveVedioUrl != null || this.newsLive.liveVedioUrl != '') && (this.newsLive.vedioUrl == null || this.newsLive.vedioUrl == '')){
            if(this.newsLive.isOpenVideo == '0'){
              this.isShowVideo = false;
            }else{
              arr = this.newsLive.liveVedioUrl.split(".");
              if(arr[arr.length-1] == "m3u8"){
                videoType="application/x-mpegURL"
              }else if(arr[arr.length-1] == "mp4"){
                videoType="video/mp4"
              }
              srcUrl = this.newsLive.liveVedioUrl;

              container.innerHTML = '<video id="my-video" style="height: 210px;width: 100%;" class="video-js vjs-big-play-centered" x-webkit-airplay="allow" webkit-playsinline controls poster="'+this.newsLive.vedioImage+'" preload="auto" style="width: 100%;"  data-setup=\'{"preload":"auto","controls":true}\'><source src="'+srcUrl+'" type="'+videoType+'" ></video>';
            }


          }else if(this.newsLive.liveVedioUrl != null || this.newsLive.vedioUrl != null){
            arr = this.newsLive.vedioUrl.split(".");
            if(arr[arr.length-1] == "m3u8"){
              videoType="application/x-mpegURL"
            }else if(arr[arr.length-1] == "mp4"){
              videoType="video/mp4"
            }
            srcUrl = this.newsLive.vedioUrl;
            var container = document.getElementById('live');
            container.innerHTML = '<video id="my-video" style="height: 210px;width: 100%;" class="video-js vjs-big-play-centered" x-webkit-airplay="allow" webkit-playsinline controls poster="'+this.newsLive.vedioImage+'" preload="auto" style="width: 100%;"  data-setup=\'{"preload":"auto","controls":true}\'><source src="'+srcUrl+'" type="'+videoType+'" ></video>';
          }

          /*var myPlayer = neplayer('my-video',{
           "height": 210,
           });*/
          /*var myPlayer = neplayer("my-video", {
           "height": 210,
           }, function(){
           // 当播放器初始化完成时运行的回调函数
           });*/

        }
      })
    },
    getCommentMescrollDown(tabType){
      return {
        auto: true,
        callback: this.downCallback,
      }
    },
    getCommentMescrollUp(tabType){
      return {
        auto: false,
        callback: this.upCallback,
        page:{
          num : 0,
        },
        htmlNodata: '<p class="upwarp-nodata">-- END --</p>',
      }
    },
    upCallback(page, mescroll){
      let params = {"newsId": this.newsId, "pageNo": page.num}
      getCommentList(params).then((res) => {
        if (res.code == 0) {
          var pageList = res.data.content;
          if (pageList.length > 0) {
            for (let i = 0; i < pageList.length; i++) {
              this.newCommentList.push(pageList[i])
            }
            mescroll.endSuccess(pageList.length);// 联网成功的回调,隐藏下拉刷新和上拉加载的状态;
          }else{
            mescroll.endSuccess(page.num,false);// 联网成功的回调,隐藏下拉刷新和上拉加载的状态;
          }
        }else{
          mescroll.endSuccess(page.num,false);// 联网成功的回调,隐藏下拉刷新和上拉加载的状态;
        }
      })
    },
    getMessageMescrollDown (tabType) {
      let isAuto = tabType === 0; // 第一个mescroll传入true,列表自动加载
      return {
        auto: isAuto,
        callback: this.downCallback,
        /*toTop: { // 配置回到顶部按钮
         src: '/mescroll/mescroll-totop.png', // 图片路径,默认null (建议写成网络图,不必考虑相对路径)
         warpClass: 'mescroll-totop', // 按钮样式,参见mescroll.css
         offset: 400, // 列表滚动多少距离才显示回到顶部按钮,默认1000
         },*/
        /*htmlNodata: '<p class="upwarp-nodata">-- END --</p>',*/
      }
    },
    downCallback (mescroll) {
      // 这里加载你想下拉刷新的数据, 比如刷新tab1的轮播数据
      if (mescroll.tabType === 0) {
        this.getLiveMessage();
        mescroll.endSuccess(this.liveMessageList.length);// 联网成功的回调,隐藏下拉刷新和上拉加载的状态;
      } else if (mescroll.tabType === 1) {
        this.newCommentList.length = 0;
        mescroll.resetUpScroll();
      }
      //mescroll.resetUpScroll();// 触发下拉刷新的回调,加载第一页的数据
    },
    getLiveMessage(){
      let params = {"newsId":this.newsId,timestamp:this.timestamp}
      getLiveMessage(params).then((res) => {
        if(res.code == 0 && res.data.messages != null){
          this.list = res.data.messages;
          this.timestamp = res.data.timestamp;
          for(var i=0;i<this.list.length;i++){
            if(this.list[i].isTop == 1){
              this.topMessageList.push(this.list[i]);
            }else{
              this.liveMessageList.push(this.list[i])
            }
          }

          //this.liveMessageList.reverse();
          this.replaceVideo();
          this.close();
        }
      })
    },
    open(){
      $("#body").removeClass('sub_body');
      document.getElementById("triangle-down").style.display = "none"
      document.getElementById("triangle-up").style.display = "block"
      document.getElementById("body").style.display = "block"
    },
    close(){
      var aa = document.getElementById("content").scrollHeight;
      document.getElementById("body").style.display = "none"
      document.getElementById("triangle-down").style.display = "block"
      document.getElementById("triangle-up").style.display = "none"
    },
    changeOrder(){
      if(this.descMessage === '顺序'){
        this.isDesc = false;
        this.descMessage = '倒序';
      }else{
        this.isDesc = true;
        this.descMessage = '顺序';
      }
      this.liveMessageList.reverse();
      this.replaceVideo();
    },
    // 获取菜单对应的数据
    getTabData (tabType) {
      if (tabType == null) tabType = this.tabType;
      if (tabType === 0) {
        return this.tab0;
      } else if (tabType === 1) {
        return this.tab1;
      }
    },
    // 切换菜单
    changeTab (type) {
      let curTab = this.getTabData(this.tabType);// 当前列表
      let newTab = this.getTabData(type);// 新转换的列表
      if(type === 0){
        this.getMessageMescrollDown();
        this.isShowCommentInput = false;
      }else{
        this.isShowCommentInput = true;
      }
      //curTab.mescroll.hideTopBtn(); // 隐藏当前列表的回到顶部按钮
      this.tabType = type // 切换菜单
      if (!newTab.isListInit) {
        //newTab.mescroll.triggerDownScroll(); // 加载列表
      } else {
        /*setTimeout(() => {
         // 检查新转换的列表是否需要显示回到到顶按钮
         var curScrollTop = newTab.mescroll.getScrollTop();
         if (curScrollTop >= newTab.mescroll.optUp.toTop.offset) {
         newTab.mescroll.showTopBtn();
         } else {
         newTab.mescroll.hideTopBtn();
         }
         }, 30)*/
      }
    },
    replaceVideo(){
      this.htmlList.length = 0;
      this.$nextTick(() => {
        $("p").css("margin","0px 0px");
        $("#liveMessageContent video").attr("name","myVideo");
        this.srcList =document.getElementsByName("myVideo");
        for(var i=0;i<this.srcList.length;i++){
          this.srcList[i].setAttribute("id",'video'+(i+1))
          var videoUrl = "";
          if(this.srcList[i].src == ''){
            var source = document.getElementById("video"+(i+1)).getElementsByTagName("source");
            videoUrl = source[0].getAttribute("src")
          }else{
            videoUrl = this.srcList[i].src
          }
          var html = "<div class='video-div' style='background-image: url("+this.srcList[i].poster+");'  id='my_name' data-video-url='"+videoUrl+"' data-isVideo='true'>"+
            "<div class='video-div-div' id='my_name'  data-video-poster='"+this.srcList[i].poster+"' data-video-url='"+videoUrl+"' data-isVideo='true'>"+
            "<div class='video-play' id='my_name'  data-video-poster='"+this.srcList[i].poster+"' data-video-url='"+videoUrl+"' data-isVideo='true'>"+
            "</div>"+
            "</div>"+
            "</div>";
          this.htmlList.push(html);
        }

        for(var j = 0;j<this.htmlList.length;j++){
          $('#video'+(j+1)).replaceWith(this.htmlList[j]);
        }
        /*let imgs = document.getElementById("liveMessageContent").getElementsByTagName("img")
         for (let i in imgs) {
         if (typeof imgs[i] === 'object'){
         imgs[i].onload = (()=> {

         })
         }
         }*/
      })
    },
    openVideo: function (event) {
      if (event.target.id === 'my_name') {
        var videoUrl = event.target.getAttribute("data-video-url");
        var imgUrl = event.target.getAttribute("data-video-poster");
        this.$router.push({ path: '/qf/live_video_detail', query: { poster: imgUrl,src:videoUrl,newsId:this.newsId }});
      }
    },

  },

}



// WEBPACK FOOTER //
// ./src/pages/qf/live_detail.vue